import { Skeleton, Stack } from "@mui/material";
import { TierIiReportStep } from "generated-graphql/graphql";
import { ProductsTable } from "../../ProductsTable";
import { ReportFloatingBar } from "../ReportFloatingBar";
import { useProductIssues, useReport } from "../useReport";
import { useTouchReportMutation } from "../useTouchReportMutation";
import { useNavigateReportSaveCancel } from "../useNavigateReportSaveCancel";

export function ProductsReportStep() {
  const { data } = useReport();
  const issues = useProductIssues();

  const facilityId = data?.tierIIReport.facility.id ?? "";
  const reportId = data?.tierIIReport.id ?? "";
  const navigateToOverview = useNavigateReportSaveCancel();
  const { handleSave, loading } = useTouchReportMutation(
    reportId,
    data?.tierIIReport.touchedSteps ?? [],
    TierIiReportStep.Products
  );

  if (!data?.tierIIReport.facility) {
    return <Skeleton />;
  }

  return (
    <>
      <Stack
        sx={{
          flexDirection: "column",
          height: "100%",
        }}
      >
        <ProductsTable facilityId={facilityId} />
      </Stack>
      <ReportFloatingBar
        loading={loading}
        onSaveClick={handleSave}
        onCancel={navigateToOverview}
        issues={issues}
        disabledWithAnyIssues
        saveText="Mark as Complete"
      />
    </>
  );
}
